import moment from "moment"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetAntrepoOutListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    antrepoExitDateStart: string | undefined
    antrepoExitDateEnd: string | undefined
    selectedSenderFirm: CustomSingleSelectModel | undefined
    selectedReceiverFirm: CustomSingleSelectModel | undefined
    selectedVehicle: CustomSingleSelectModel | undefined
    selectedTrailer: CustomSingleSelectModel | undefined
    selectedSupplier: CustomSingleSelectModel | undefined
    selectedExitType: CustomSingleSelectModel | undefined
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetAntrepoOutListPagingAndFilterRequest: GetAntrepoOutListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    antrepoExitDateStart: undefined,
    antrepoExitDateEnd: undefined,
    selectedSenderFirm: undefined,
    selectedVehicle: undefined,
    selectedTrailer: undefined,
    selectedSupplier: undefined,
    selectedExitType: undefined,
    selectedReceiverFirm: undefined,
    columnFilters: []
}